import React from 'react'
import PolicyBody from './Policybody'
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'

export default class Component extends React.Component {
  render = () => {
    const metaInfo = (
      <Helmet>
        <title>プライバシーポリシー | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)のプライバシーポリシーページです。お客様の個人情報保護方針などを記載しています。' />
      </Helmet>
    )

    return (
      <section className='privacyPolicy container'>
        {metaInfo}
        <h2 className='headline'>プライバシーポリシー</h2>
        <PolicyBody />
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/StaticPages/PrivacyPolicy/Policy.jsx